module.exports = __webpack_public_path__ + "img/content-image-2.77df4742.png";